import React from "react";
import PropTypes from "prop-types";
import BookPreview from "../../components/BookPreview";
import CanvasDrawers from "../../components/CanvasDrawers";
import Highlights from "../../components/Highlights";

import "./Canvas.scss";

const Canvas = (props) => (
  <section className="canvas">
    <h1 className="canvas-title">{props.title}</h1>
    <BookPreview
      covers={props.primary.bookPages}
      hasDynamicBreadcrumbs={props.primary.hasDynamicBreadcrumbs}
      breadcrumbCTA={props.primary.breadcrumbsCta}
      breadcrumbs={props.primary.breadcrumbs}
      sortBreadcrumbs={props.primary.sortBreadcrumbs}
      productId={props.primary.productId}
      productMuseId={props.productMuseId}
      drawers={props.drawers}
      completedDrawersMap={props.completedDrawersMap}
    />
    {props.primary.productHighlights && (
      <Highlights
        ctaText={props.primary.productHighlights.ctaText}
        slides={props.primary.productHighlights.content}
      />
    )}
    {props.isDrawersVisible && (
      <CanvasDrawers
        productId={props.primary.productId}
        prismicProduct={props.prismicProduct}
        drawers={props.drawers}
        cancelCta={props.primary.cancelCta}
        completedText={props.completedCtaText}
        continueText={props.continueCtaText}
        completedDrawersMap={props.completedDrawersMap}
        showSaveForLater={props.primary.showSaveForLater}
        checkWork={props.primary.checkWork}
      />
    )}
    <div
      className={`canvas-overlay ${
        props.isDrawerOpen ? "canvas-overlay--visible" : ""
      }`}
    />
  </section>
);

Canvas.propTypes = {
  isDrawersVisible: PropTypes.bool.isRequired,
  isDrawerOpen: PropTypes.bool.isRequired,
  completedDrawersMap: PropTypes.object.isRequired,
  completedCtaText: PropTypes.string.isRequired,
  continueCtaText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  primary: PropTypes.shape({
    cancelCta: PropTypes.string.isRequired,
    cta: PropTypes.string.isRequired,
    hasGiftwrap: PropTypes.bool,
    productId: PropTypes.string.isRequired,
    bookPages: PropTypes.array.isRequired,
    breadcrumbs: PropTypes.array,
    hasDynamicBreadcrumbs: PropTypes.bool,
    breadcrumbsCta: PropTypes.string,
    sortBreadcrumbs: PropTypes.string,
    productHighlights: PropTypes.object,
    showSaveForLater: PropTypes.bool,
    checkWork: PropTypes.shape({
      show: PropTypes.bool,
      title: PropTypes.string,
      description: PropTypes.string,
      ctaBackText: PropTypes.array,
      ctaHelper: PropTypes.string,
      ctaText: PropTypes.string,
      drawerKey: PropTypes.string,
    }),
  }),
  drawers: PropTypes.shape({
    form: PropTypes.object,
    other: PropTypes.array,
  }),
  prismicProduct: PropTypes.object,
  showSaveForLaterButton: PropTypes.bool,
  productMuseId: PropTypes.string,
};

export default Canvas;
